import { GPTGameNameType } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';

export const GPT_BANNER_CONFIG: Partial<Record<GPTGameNameType, BannerProps>> = {
  cardGame: {
    background: 'linear-gradient(149deg, #F34D00 8.2%, #D357FE 57.8%, #FDC700 101.15%)',
    boxShadow: '-1px 4px 9px 0 #F87171',
    textShadow: '0px 2px 4px rgba(212, 0, 4, 0.93)'
  },
  wheelOfFortune: {
    background: 'linear-gradient(145.75deg, #9B55FD 14.02%, #1D4ED8 57.77%, #60A5FA 86.59%)',
    boxShadow: '-5px 3px 17px 0px #7a73e5',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.78)'
  },
  birdGame: {
    background: 'linear-gradient(149deg, #F34D00 8.2%, #D357FE 57.8%, #FDC700 101.15%)',
    boxShadow: '-1px 4px 9px 0 #F87171',
    textShadow: '0px 2px 4px rgba(212, 0, 4, 0.93)'
  }
};

export type BannerProps = {
  background: string;
  boxShadow: string;
  textShadow: string;
};
